export default __webpack_public_path__ + "static/media/ic_back.7fd85b56.svg";